/* global mediaServerThemeRootUrl */

import intlTelInput from 'intl-tel-input';
import {
  getStyleguideClasses,
  isMobile,
  validatePhoneNumber,
} from './index.js';

const getInitOptions = (defaultCountry, wrapperClass, form) => {
  const options = {
    utilsScript:
      mediaServerThemeRootUrl + '/js/vendors/intl-tel-input-utils.js',
    separateDialCode: true,
    autoPlaceholder: 'off',
    initialCountry: defaultCountry,
    preferredCountries: [defaultCountry],
    formatOnDisplay: false,
  };
  if (isMobile()) {
    let dropdownContainer = `${wrapperClass}` + ' .phone__wrapper';
    if (form !== null) {
      const formId = form.el.getAttribute('id');
      dropdownContainer = `#${formId} ` + dropdownContainer;
    }

    options.dropdownContainer = document.querySelector(dropdownContainer);
  }
  return options;
};

function sanitizePhoneInput(phoneEl) {
  // Store current positions and value in variables
  const start = phoneEl.selectionStart;
  const end = phoneEl.selectionEnd;
  const inputValue = phoneEl.value;

  // Replace the first '00' with '+'
  phoneEl.value = phoneEl.value.replace(/^00/g, '+');

  // Keeps the pointer position
  if (inputValue.length > phoneEl.value.length) {
    phoneEl.setSelectionRange(start - 1, end - 1);
  }
}

function handleInputChange(e) {
  sanitizePhoneInput(e.target);
}

const initIntTelInput = ({
  input,
  locale,
  wrapperClass,
  validation = false,
  form = null,
}) => {
  if (!input) return;

  const intlTelInputInstance = intlTelInput(
    input,
    getInitOptions(locale, wrapperClass, form)
  );

  sanitizePhoneInput(input);
  input.addEventListener('change', handleInputChange);
  input.addEventListener('keyup', handleInputChange);

  if (validation) {
    form.submitButton.addEventListener('click', (e) => {
      e.preventDefault();

      const inputValidation = validatePhoneNumber(
        intlTelInputInstance,
        input.value.trim(),
        false,
        $(form.el).find(wrapperClass)
      );

      if (inputValidation.isValid) {
        input.removeEventListener('change', handleInputChange);
        input.removeEventListener('keyup', handleInputChange);

        // Update input with the number and prefix on submit
        // The plugin doesn't do it automatically, to save the whole phone number
        input.value = intlTelInputInstance.getNumber();
        form.el.submit();
      } else {
        $(form.submitButton).removeClass(
          ...getStyleguideClasses(['btn--loading'])
        );
      }
    });
  }

  return intlTelInputInstance;
};

export default initIntTelInput;
